<!--菜单栏气泡标签组件 -->
<template>
  <div class="menu-tag" v-if="init">
    <div 
      :class="[menuStyle=='sidebar'?'sidebar':'nosidebar']" 
      v-if="init && ((init.text && init.type == 'text') || (init.image && init.type == 'image'))"  
      @click.stop.prevent="()=>{}"
    >
      <!--菜单栏气泡:文本 -->
      <div 
        v-if="isText"  
        :class="[menuStyle=='sidebar'?'sidebar__text':'nosidebar__text']"
      >
        <!--菜单栏气泡：对应一级菜单 -->
        <div 
          v-if="isTop" 
          :class="[menuStyle=='sidebar'?'sidebar__text-top':'nosidebar__text-top']" 
          :style="{color:color,backgroundColor:bgColor}"
        >
          {{itemText}}
        </div>
        <!--菜单栏气泡：对应非一级菜单 -->
        <div 
          v-else 
          :class="[menuStyle=='sidebar'?'sidebar__text-nottop':'nosidebar__text-nottop']" 
          :style="{color:color,backgroundColor:bgColor}"
        >
          {{itemText}}
        </div>
      </div>
      <!--菜单栏气泡:图像 -->
      <div 
        v-else 
        :class="[menuStyle=='sidebar'?'sidebar__img':'nosidebar__img']" 
      >
        <img 
          :src="url"
          :class="[menuStyle=='sidebar'?'sidebar__img-warp':'nosidebar__img-warp']">
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  props: {
    menuStyle: { //sidebar:侧边栏;  //{ center:logo居中; left:logo居左; wide:横向;}: nosidebar
      type: String,
      required: true,
    },
    isTop: {  //判断当前菜单是否是一级菜单
      type: Boolean,
      default: false,
    },
    itemTitle: { //当前菜单名称
      type: String,
      default:null,
    },
  },
  data() {
    return {
      itemText:'',
      url:'',
      color:'',
      bgColor:'',
    }
  },
  computed: {
    //从vuex中获取气泡标签列表
    ...mapState({
      list: ({ options }) => (options?.theme?.modules?.header?.tipItems) ?? (options?.theme?.modules?.nav?.tipItems)
    }),
    //筛选匹配对应菜单栏的气泡标签的配置
    init() {
      let items = [] 
      this.list?.forEach((el,index )=>{ 
        if(el.menu_name){
          const strA = el.menu_name.toLocaleLowerCase().trim()
          const strB = this.itemTitle.toLocaleLowerCase().trim()
          if(strA == strB){
            items.push(el)
          }
        }
      })
      let item = items[items.length>1?items.length-1:0]
      if(item){
        this.color = item.text_color
        this.bgColor = item.background_color
      }
      return item
    },
    //判断该气泡标签的类型：文本；图像
    isText() {
      let tag = this.init 
      if(tag?.type == 'image') {
        this.url = tag.image.url
        return false
      }else {
        this.itemText = tag.text
        return true
      }
    }
  },
}
</script>

<style scoped lang='scss'>
.menu-tag {
  display:inline-flex; 
  align-items: center;
  flex: 1;
  .sidebar {
    margin-left: 4px;
    &__text-top,&__text-nottop {
      font-size: 14px;
      width: max-content;
      margin-top: -5px;
    }
    &__text-top {
      height: 18px;
      line-height: 18px;
      padding: 0px 4px 0px 12px;
      clip-path: polygon(10px 0px, 100% 0, 100% 0, 100% 100%, 100% 100%, 10px 100%, 0 50%, 0 50%);
    }
    &__text-nottop {
      font-size: 12px;
      height: 16px;
      line-height: 16px;
      padding: 0px 6px;
      border-radius: 8px ;
      border-bottom-left-radius: 0 !important; 
    }
    &__img {
      margin-top: -5px;
    }
    &__img-warp{
      max-height: 20px ;
      max-width: 110px;
    }
  }
  .nosidebar {
    margin-left: 4px;
    &__text-top,&__text-nottop {
      font-size: 14px;
      width: max-content;
      padding: 0px 6px;
    }
    &__text-top {
      height: 22px;
      line-height: 18px;
      clip-path: polygon(0px 0px, 100% 0, 100% 0, 100% calc(100% - 4px), calc(50% + 4px ) calc(100% - 4px), 50% 100%, calc(50% - 4px ) calc(100% - 4px), 0 calc(100% - 4px));
    }
    &__text-nottop {
      font-size: 12px;
      height: 16px;
      line-height: 16px;
      border-radius: 8px ;
      border-bottom-left-radius: 0 !important; 
    }
    &__img-warp{
      max-height: 20px ;
      max-width: 110px;
    }
  }
}
@media screen and (max-width: 767px) {
  .no-sidebar-top {  
    .nosidebar {
      &__text-top,&__text-nottop {
        font-size: 14px;
        width: max-content;
      }
      &__text-top {
        height: 18px;
        line-height: 18px;
        padding: 0px 4px 0px 12px;
        clip-path: polygon(10px 0px, 100% 0, 100% 0, 100% 100%, 100% 100%, 10px 100%, 0 50%, 0 50%);
      }
      &__text-nottop {
        font-size: 12px;
        height: 16px;
        line-height: 16px;
        padding: 0px 6px;
        border-radius: 8px ;
        border-bottom-left-radius: 0 !important; 
      }
      &__img{
        margin: 0px;
      }
      &__img-warp{
        max-height: 20px ;
        max-width: 110px;
      }
    }
  }
  .second,.child_class{
    .menu-tag{
      align-items: flex-end !important;
    }
  }
}
</style>